module.exports = __webpack_public_path__ + "img/Weapon_58.e7b50bb7.png";